// extracted by mini-css-extract-plugin
export default {"base":"TopBar_base__AgZq9","left-slot":"TopBar_left-slot__aoe-a","right-slot":"TopBar_right-slot__XtNoO"};